export default __webpack_public_path__ + "static/media/tramstation.06cbcae2.svg";